import type { CityConfig } from "@/pages/city-template/types";

export const longIslandConfig: CityConfig = {
  city: "Long Island",
  state: "New York",
  stateAbbr: "NY",
  slug: "long-island",
  route: "/cities/long-island",
  title: "Emergency & Expedited Passport Long Island NY | Nassau & Suffolk County",
  metaDescription:
    "Emergency passport Long Island NY — same day, 24-hour, and 3-5 day expedited passport processing for Nassau and Suffolk County. Fast Passport Center serves Hempstead, Islip, Huntington, Smithtown, and all Long Island communities.",
  h1: "Emergency & Expedited Passport Services in Long Island, NY",
  heroSubtitle:
    "Long Island's fast passport solution — from Nassau to Suffolk County. Whether you're flying out of JFK, LaGuardia, or Long Island MacArthur, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Beautiful%20Long%20Island%20New%20York%20coastline%20at%20golden%20hour%20with%20sandy%20beach%2C%20Montauk%20Point%20lighthouse%20in%20distance%2C%20North%20Shore%20Gold%20Coast%20mansions%20along%20the%20shoreline%2C%20suburban%20tree-lined%20neighborhoods%2C%20warm%20golden%20afternoon%20light%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20scenic%20coastal%20Long%20Island%20New%20York%20scene%20with%20ocean%20and%20sky&width=1600&height=700&seq=ny-long-island-hero-001&orientation=landscape",
  heroImageAlt: "Long Island New York coastline with North Shore mansions and beach at golden hour",
  geoPosition: "40.8523; -73.4198",
  geoPlacename: "Long Island, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~25-40 miles (via LIRR or Long Island Expressway)",
  },
  nearbyCitiesZips: [
    { name: "Hempstead", zips: "11550, 11551, 11552, 11553, 11554, 11555, 11556, 11557" },
    { name: "Levittown", zips: "11756, 11714" },
    { name: "Hicksville", zips: "11801, 11802, 11815, 11819, 11854, 11855" },
    { name: "Islip", zips: "11751, 11752" },
    { name: "Huntington", zips: "11743, 11721, 11740, 11746, 11747, 11750" },
    { name: "Smithtown", zips: "11745, 11754, 11780, 11787, 11788" },
    { name: "Commack", zips: "11725" },
    { name: "Bay Shore", zips: "11706, 11769" },
    { name: "West Babylon", zips: "11704, 11707" },
    { name: "New York City", zips: "10001-10282, 11201-11251" },
    { name: "Brooklyn", zips: "11201-11256" },
    { name: "Queens", zips: "11001-11697" },
    { name: "Yonkers", zips: "10701-10710" },
    { name: "Stamford", zips: "06901-06907, 06910, 06911, 06912, 06914, 06926, 06927" },
    { name: "Bridgeport", zips: "06601-06608, 06610, 06650, 06673, 06699" },
    { name: "Norwalk", zips: "06850-06860, 06880, 06881, 06885, 06888, 06889, 06890, 06897, 06898, 06902" },
    { name: "Garden City", zips: "11530, 11531, 11535, 11599" },
    { name: "Mineola", zips: "11501" },
    { name: "Great Neck", zips: "11020-11027" },
    { name: "Port Washington", zips: "11050, 11052, 11053, 11054, 11055, 11051" },
    { name: "Glen Cove", zips: "11542, 11545" },
    { name: "Oyster Bay", zips: "11771" },
    { name: "Massapequa", zips: "11758, 11762" },
    { name: "Wantagh", zips: "11793" },
    { name: "East Meadow", zips: "11554" },
    { name: "Freeport", zips: "11520" },
    { name: "Baldwin", zips: "11510" },
    { name: "Rockville Centre", zips: "11570, 11571, 11572" },
    { name: "Lynbrook", zips: "11563, 11564" },
    { name: "Valley Stream", zips: "11580, 11581, 11582" },
    { name: "Elmont", zips: "11003" },
    { name: "Floral Park", zips: "11001, 11002, 11005" },
    { name: "Bethpage", zips: "11714" },
    { name: "Plainview", zips: "11803" },
    { name: "Syosset", zips: "11773, 11791" },
    { name: "Jericho", zips: "11753" },
    { name: "Woodbury", zips: "11797" },
    { name: "Roslyn", zips: "11576, 11577" },
    { name: "Manhasset", zips: "11030" },
    { name: "Port Jefferson", zips: "11777" },
    { name: "Stony Brook", zips: "11790, 11794" },
    { name: "Setauket", zips: "11733" },
    { name: "Patchogue", zips: "11772" },
    { name: "Shirley", zips: "11967" },
    { name: "Riverhead", zips: "11901" },
    { name: "Southampton", zips: "11968, 11969" },
    { name: "East Hampton", zips: "11937" },
    { name: "Montauk", zips: "11954" },
    { name: "Westbury", zips: "11568, 11590, 11594, 11595, 11597" },
    { name: "Uniondale", zips: "11553, 11555, 11556" },
    { name: "Roosevelt", zips: "11575" },
    { name: "North Bellmore", zips: "11710" },
    { name: "Bellmore", zips: "11710" },
    { name: "Merrick", zips: "11566" },
    { name: "Seaford", zips: "11783" },
    { name: "Amityville", zips: "11701, 11702, 11708, 11726" },
    { name: "Copiague", zips: "11726, 11757" },
    { name: "Lindenhurst", zips: "11757" },
    { name: "North Babylon", zips: "11703" },
    { name: "Deer Park", zips: "11729" },
    { name: "Dix Hills", zips: "11746" },
    { name: "Melville", zips: "11747, 11775" },
    { name: "Farmingdale", zips: "11735, 11737" },
    { name: "Brentwood", zips: "11717" },
    { name: "Central Islip", zips: "11722" },
    { name: "Hauppauge", zips: "11749, 11760, 11788" },
    { name: "Kings Park", zips: "11754" },
    { name: "Northport", zips: "11768" },
    { name: "East Northport", zips: "11731" },
    { name: "Greenlawn", zips: "11740" },
    { name: "Halesite", zips: "11743" },
    { name: "Huntington Station", zips: "11746, 11750" },
    { name: "Huntington Beach", zips: "11743" },
    { name: "Cold Spring Harbor", zips: "11724" },
    { name: "Lloyd Harbor", zips: "11743" },
    { name: "Centerport", zips: "11721" },
    { name: "Fort Salonga", zips: "11768" },
    { name: "Suffolk", zips: "11932" },
    { name: "Nassau", zips: "11510" },
    { name: "Sag Harbor", zips: "11963" },
    { name: "Sagaponack", zips: "11962" },
    { name: "Bridgehampton", zips: "11932" },
    { name: "Water Mill", zips: "11976" },
    { name: "Wainscott", zips: "11975" },
    { name: "Amagansett", zips: "11930" },
    { name: "Springs", zips: "11937" },
    { name: "North Haven", zips: "11963" },
    { name: "Quogue", zips: "11959" },
    { name: "Westhampton", zips: "11977" },
    { name: "Westhampton Beach", zips: "11978" },
    { name: "Remsenburg", zips: "11960" },
    { name: "Speonk", zips: "11972" },
    { name: "East Moriches", zips: "11940" },
    { name: "Center Moriches", zips: "11934" },
    { name: "Moriches", zips: "11955" },
    { name: "Manorville", zips: "11949" },
    { name: "Calverton", zips: "11933" },
    { name: "Wading River", zips: "11792" },
    { name: "Shoreham", zips: "11786" },
    { name: "Rocky Point", zips: "11778" },
    { name: "Miller Place", zips: "11764" },
    { name: "Mount Sinai", zips: "11766" },
    { name: "Port Jefferson Station", zips: "11776" },
    { name: "Terryville", zips: "11776" },
    { name: "Coram", zips: "11727" },
    { name: "Selden", zips: "11784" },
    { name: "Medford", zips: "11763" },
    { name: "Farmingville", zips: "11738" },
    { name: "Holbrook", zips: "11741" },
    { name: "Holtsville", zips: "11742, 11701" },
    { name: "Lake Ronkonkoma", zips: "11779" },
    { name: "Ronkonkoma", zips: "11779" },
    { name: "Bohemia", zips: "11716" },
    { name: "Oakdale", zips: "11769" },
    { name: "Sayville", zips: "11782" },
    { name: "Bayport", zips: "11705" },
    { name: "Blue Point", zips: "11715" },
    { name: "West Sayville", zips: "11796" },
    { name: "East Islip", zips: "11730" },
    { name: "Islip Terrace", zips: "11752" },
    { name: "Great River", zips: "11739" },
    { name: "Oak Beach", zips: "11702" },
    { name: "Gilgo", zips: "11702" },
    { name: "West Islip", zips: "11795" },
    { name: "North Massapequa", zips: "11758" },
    { name: "Massapequa Park", zips: "11762" },
    { name: "Seaford", zips: "11783" },
    { name: "Plainedge", zips: "11714" },
    { name: "Bethpage", zips: "11714" },
    { name: "Farmingdale", zips: "11735" },
    { name: "Old Bethpage", zips: "11804" },
    { name: "Plainview", zips: "11803" },
    { name: "Woodbury", zips: "11797" },
    { name: "Syosset", zips: "11773, 11791" },
    { name: "Jericho", zips: "11753" },
    { name: "Muttontown", zips: "11771, 11732" },
    { name: "Brookville", zips: "11545, 11548" },
    { name: "Upper Brookville", zips: "11732" },
    { name: "Old Westbury", zips: "11568" },
    { name: "East Hills", zips: "11548, 11576, 11577" },
    { name: "Roslyn Heights", zips: "11577" },
    { name: "Roslyn Estates", zips: "11576" },
    { name: "Roslyn Harbor", zips: "11576" },
    { name: "Sands Point", zips: "11050" },
    { name: "Port Washington North", zips: "11050" },
    { name: "Baxter Estates", zips: "11050" },
    { name: "Manorhaven", zips: "11050" },
    { name: "Plandome", zips: "11030" },
    { name: "Plandome Heights", zips: "11030" },
    { name: "Plandome Manor", zips: "11030" },
    { name: "Flower Hill", zips: "11030" },
    { name: "Kensington", zips: "11021" },
    { name: "Thomaston", zips: "11021" },
    { name: "Great Neck Estates", zips: "11021" },
    { name: "Great Neck Plaza", zips: "11021" },
    { name: "Kings Point", zips: "11024" },
    { name: "Saddle Rock", zips: "11023" },
    { name: "Saddle Rock Estates", zips: "11021" },
    { name: "Lake Success", zips: "11020, 11042" },
    { name: "North New Hyde Park", zips: "11040, 11042" },
    { name: "New Hyde Park", zips: "11040, 11041, 11042, 11043, 11044, 11099" },
    { name: "Garden City Park", zips: "11040" },
    { name: "Stewart Manor", zips: "11530" },
    { name: "Malverne", zips: "11565" },
    { name: "West Hempstead", zips: "11552" },
    { name: "South Hempstead", zips: "11550" },
    { name: "East Rockaway", zips: "11518" },
    { name: "Lynbrook", zips: "11563" },
    { name: "Valley Stream", zips: "11580, 11581" },
    { name: "Woodmere", zips: "11598, 11516" },
    { name: "Hewlett", zips: "11557" },
    { name: "Hewlett Harbor", zips: "11557" },
    { name: "Hewlett Neck", zips: "11598" },
    { name: "Hewlett Bay Park", zips: "11509" },
    { name: "Cedarhurst", zips: "11516" },
    { name: "Lawrence", zips: "11559" },
    { name: "Inwood", zips: "11596, 11096" },
    { name: "Atlantic Beach", zips: "11509" },
    { name: "Long Beach", zips: "11561" },
    { name: "Point Lookout", zips: "11569" },
    { name: "Lido Beach", zips: "11561" },
    { name: "Island Park", zips: "11558" },
    { name: "Barnum Island", zips: "11558" },
    { name: "Harbor Isle", zips: "11558" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Long Island travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround. Available for Long Island residents 7 days a week.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Nassau & Suffolk County",
      desc: "Hempstead, Islip, Huntington, Smithtown, and all of Nassau and Suffolk County — we serve all of Long Island.",
    },
  ],
  testimonials: [
    {
      name: "Robert S.",
      location: "Huntington, Long Island",
      rating: 5,
      text: "Had a business trip to London in 4 days. Fast Passport Center got my expedited passport processed in 3 days. They even helped me find the best photo location near Huntington.",
      service: "Expedited Passport",
    },
    {
      name: "Lisa M.",
      location: "Hicksville, Long Island",
      rating: 5,
      text: "Renewed my expired passport for a family cruise. Chose the 5-day option and had it back in 4. They reviewed everything before submission.",
      service: "Passport Renewal",
    },
    {
      name: "David K.",
      location: "Islip, Long Island",
      rating: 5,
      text: "First-time passport for my son's study abroad program. The agent walked us through the DS-11 form and acceptance clerk process. Processed in 5 days.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "long-island-1",
      name: "Hicksville Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "17 West John Street",
      city: "Hicksville",
      state: "NY",
      zip: "11801",
      phone: "516-433-2222",
      hours: "Mon-Fri 8:00 AM - 5:00 PM, Sat 9:00 AM - 1:00 PM",
      distance: "Central Nassau County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Long Island passport acceptance facility serving Nassau County. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "long-island-2",
      name: "Islip Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "130 Main Street",
      city: "Islip",
      state: "NY",
      zip: "11751",
      phone: "631-277-5255",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "South Shore Suffolk County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available by appointment. Convenient for Islip, Bay Shore, Brentwood, and South Shore Suffolk County residents.",
      icon: "ri-building-2-line",
    },
    {
      id: "long-island-3",
      name: "Huntington Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "126 East Main Street",
      city: "Huntington",
      state: "NY",
      zip: "11743",
      phone: "631-423-1964",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "North Shore Suffolk County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving Huntington, Northport, Commack, and North Shore Suffolk County communities.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport on Long Island?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Long Island residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility on Long Island?",
      a: "The Hicksville Post Office at 17 West John Street is a major Nassau County passport acceptance facility. The Islip Post Office at 130 Main Street and Huntington Post Office at 126 East Main Street serve Suffolk County. First-time applicants and those not eligible for mail-in renewal must apply in person.",
    },
    {
      q: "Can I get same-day passport photos on Long Island?",
      a: "Yes — passport photos are widely available at CVS Pharmacy, Walgreens, UPS Store, and FedEx Office locations throughout Nassau and Suffolk County including Hicksville, Huntington, Islip, and Hempstead. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost on Long Island?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Long Island passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. Long Island residents can simply ship documents via overnight courier. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport on Long Island?",
      a: "The fastest way to renew a passport on Long Island is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited on Long Island?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 on Long Island and all of Nassau and Suffolk County. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office on Long Island?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office on Long Island. We serve Nassau and Suffolk County through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Long Island", address: "various CVS locations across Nassau and Suffolk County including Hicksville, Huntington, Islip, and Hempstead", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Long Island", address: "various Walgreens locations throughout Nassau and Suffolk County", hours: "Mon-Sun, hours vary by location" },
    { name: "UPS Store — Long Island", address: "various UPS Store locations in Nassau and Suffolk County", hours: "Mon-Fri 9:00 AM - 7:00 PM, Sat 10:00 AM - 4:00 PM" },
    { name: "FedEx Office — Long Island", address: "various FedEx Office locations across Nassau and Suffolk County", hours: "Mon-Fri 8:00 AM - 9:00 PM, Sat-Sun 10:00 AM - 6:00 PM" },
    { name: "Walmart Photo Center — Long Island", address: "various Walmart locations in Nassau and Suffolk County", hours: "Mon-Sun 8:00 AM - 10:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Hempstead",
      address: "50 Clinton Street, Hempstead, NY 11550",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Major Nassau County DMV office for license renewals and REAL ID applications. Appointments strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Huntington",
      address: "200 East Main Street, Huntington, NY 11743",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Suffolk County DMV office serving North Shore communities including Huntington, Northport, and Commack.",
      featured: false,
    },
    {
      name: "NYS DMV — Medford",
      address: "2699 Route 112, Medford, NY 11763",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Suffolk County DMV office serving South Shore communities including Islip, Patchogue, and Medford.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "JFK",
      name: "John F. Kennedy International Airport",
      distance: "~15-30 miles from Nassau County",
      address: "JFK Access Road, Jamaica, NY 11430",
      note: "Major international gateway with direct flights to Europe, Asia, and worldwide destinations. Accessible via LIRR or car from Long Island.",
      flightUrl: "https://www.jfkairport.com/",
      flightLabel: "JFK Airport",
      featured: true,
    },
    {
      code: "LGA",
      name: "LaGuardia Airport",
      distance: "~15-25 miles from Nassau County",
      address: "Ditmars Boulevard, Flushing, NY 11369",
      note: "Domestic-focused airport with flights to major U.S. cities. Accessible via LIRR or car from Long Island.",
      flightUrl: "https://www.laguardiaairport.com/",
      flightLabel: "LaGuardia Airport",
      featured: true,
    },
    {
      code: "ISP",
      name: "Long Island MacArthur Airport",
      distance: "In Ronkonkoma, Suffolk County",
      address: "100 Arrival Avenue, Ronkonkoma, NY 11779",
      note: "Long Island's own airport with flights to Florida, the Caribbean, and major U.S. hubs. Perfect for Suffolk County travelers.",
      flightUrl: "https://www.macarthurairport.com/",
      flightLabel: "MacArthur Airport",
      featured: true,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Long Island travelers with urgent departures within 24 hours to 2 weeks. Direct New York Passport Agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Long Island residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Long Island residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Long Island residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 on Long Island, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Long Island residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Long Island travelers with immediate departure needs from JFK, LaGuardia, or Long Island MacArthur Airport." },
    { name: "Passport Renewal", description: "Fast passport renewal for Long Island residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Long Island residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Long Island residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Nassau and Suffolk County." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change on Long Island." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Long Island travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Long Island travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Long Island team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier from Long Island to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application directly to the New York Passport Agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Long Island address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "The Bronx", route: "/cities/the-bronx" },
    { name: "Staten Island", route: "/cities/staten-island" },
    { name: "Bay Shore", route: "/cities/bay-shore" },
    { name: "Commack", route: "/cities/commack" },
    { name: "Hicksville", route: "/cities/hicksville" },
    { name: "Huntington", route: "/cities/huntington" },
    { name: "Islip", route: "/cities/islip" },
    { name: "Levittown", route: "/cities/levittown" },
    { name: "Smithtown", route: "/cities/smithtown" },
    { name: "West Babylon", route: "/cities/west-babylon" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "Binghamton", route: "/cities/binghamton" },
    { name: "Elmira", route: "/cities/elmira" },
    { name: "Ithaca", route: "/cities/ithaca" },
    { name: "Corning", route: "/cities/corning" },
    { name: "Jamestown", route: "/cities/jamestown" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Long Island and all of Nassau and Suffolk County as a remote courier service. We do not have a physical office on Long Island, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeDistance: "Remote courier service — Long Island area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Long Island and all of Nassau and Suffolk County. From Hempstead to Montauk, from Huntington to Islip — we serve all of Long Island with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Long Island and all surrounding communities across Nassau and Suffolk County. Whether you're in Hicksville, Huntington, Islip, or Smithtown, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Long Island customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Long Island travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Long Island travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services on Long Island. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
};

export default longIslandConfig;